import { FolderHomeIcon } from './FolderHomeIcon';

/**
 * author: Mitch Berninger
 * id EF46E7D8-3062-41E5-8FC6-92D66DEF7603
 * name folder-home
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-home.svg
 * tags
 * - Files / Folders 
 * - Home Automation 
 */
export const FolderHouseIcon = FolderHomeIcon;
export default FolderHouseIcon